exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fal:before{content:\"\\22C6\"}[class*=pencil]:before{content:\"\\270E\"}[class*=fa-times]:before,[class*=fa-trash]:before{content:\"\\2715\"}.fa-arrow-to-bottom:before{content:\"\\2193\"}[class*=fa-eye]:before{content:\"\\2609\"}.fa-check:before{content:\"\\2713\"}", ""]);

// exports
